import { render, staticRenderFns } from "./MovementTableComponent.vue?vue&type=template&id=c9ce0c26"
import script from "./MovementTableComponent.vue?vue&type=script&lang=js"
export * from "./MovementTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports